import { predefinedTextState } from '../state/predefinedTextState';
import { Fetch_All_Region_Data1,GET_PREDEFINED_TEXT_REQUEST, GET_PREDEFINED_TEXT_SUCCESS, GET_PREDEFINED_TEXT_LIST_SUCCESS} from '../action/predefinedTextAction';

export function PredefinedTextReducer(state = predefinedTextState, action) {
    switch(action.type){
        case GET_PREDEFINED_TEXT_REQUEST:
            return Object.assign({}, state, {
                errorCode : 0,
                statusCode : 0,
                message : '',
                isLoading : action.isLoading
            })
        case GET_PREDEFINED_TEXT_SUCCESS:
            return Object.assign({},state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                message : action.message,
                isLoading : action.isLoading
            })
        case GET_PREDEFINED_TEXT_LIST_SUCCESS:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                predefinedTextList : action.list,
                isLoading : action.isLoading
            })
            case Fetch_All_Region_Data1:
                                                                    return Object.assign({}, state, {
                                                                        errorCode : action.errorCode,
                                                                        statusCode : action.statusCode,
                                                                        regionList : action.regionList
                                                                    })
        default:
            return state
    }
}